import { TUser } from "@sharedTypes/res.type";
import { createContext } from "react";
export type TLoginStatus = "loading" | "invalid" | "logged in";

type TUserContext = {
  loginStatus: TLoginStatus;
  user: TUser;
  setUser: React.Dispatch<React.SetStateAction<TUser>>;
};

const UserContext = createContext<TUserContext>({
  loginStatus: "loading",
  user: {
    id: "",
    email: "",
    isAdmin: false,
    firstName: "",
    lastName: "",
  },
  setUser: () => {},
});

export default UserContext;
